import React from 'react';
import { Home, DollarSign, Dumbbell, Activity } from 'lucide-react';

const WhyRevibe = () => {
  const features = [
    {
      id: '01',
      title: 'No Travel Needed',
      description: 'Simply open your phone and start your workout instantly.',
      icon: Home,
    },
    {
      id: '02',
      title: 'Affordable Plans',
      description: 'Flexible and affordable plans designed to fit your lifestyle.',
      icon: DollarSign,
    },
    {
      id: '03',
      title: 'Expert Trainers',
      description: 'Professional trainers guide your posture and performance.',
      icon: Dumbbell,
    },
    {
      id: '04',
      title: 'Unlimited Fun',
      description: 'Enjoy Yoga, Pilates, and Strength Training sessions.',
      icon: Activity,
    },
  ];

  return (
    <div className="bg-gray-100 px-6 py-12 font-sans">
        {/* Yellow Badge */}
        <div className="inline-flex items-center bg-yellow-400 rounded-full px-4 py-1 mb-6 shadow-sm">
          <span className="text-black text-sm font-bold flex items-center">
            ✦ Why Revibe
          </span>
        </div>

        {/* Header Section */}
        <h1 className="text-3xl md:text-4xl font-bold text-gray-900 leading-tight mb-4">
          Why people choose <br />
          <span className="text-lime-500">Revibe over the gym</span>
        </h1>
        
        <p className="text-gray-600 text-base md:text-lg mb-8 md:mb-10 leading-relaxed">
          A smarter, more joyful way to stay fit — built for your real life.
        </p>

        {/* Features Grid - 2 columns on web, 1 column on mobile */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
          {features.map((feature) => {
            const IconComponent = feature.icon;
            return (
              <div 
                key={feature.id} 
                className="relative bg-white border border-gray-200 rounded-3xl p-5 flex items-center gap-5 shadow-sm overflow-hidden"
              >
                {/* Icon with Lucide */}
                <div className="w-16 h-16 bg-lime-50 rounded-2xl flex-shrink-0 flex items-center justify-center text-lime-500">
                  <IconComponent size={32} />
                </div>

                {/* Text Content */}
                <div className="flex-1 pr-8">
                  <h3 className="text-xl font-bold text-gray-900 mb-1">
                    {feature.title}
                  </h3>
                  <p className="text-gray-500 text-sm leading-snug">
                    {feature.description}
                  </p>
                </div>

                {/* Background Numbering (Watermark style) */}
                <span className="absolute right-4 bottom-2 text-5xl font-black text-gray-100 select-none">
                  {feature.id}
                </span>
              </div>
            );
          })}
        </div>
      </div>
  );
};

export default WhyRevibe;